import React from 'react';
import { FormField, Input } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { dataHooks } from '../../datahooks';
import s from './StoreNameInput.scss';

interface StoreNameInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function StoreNameInput({ value, onChange }: StoreNameInputProps) {
  const { t } = useTranslation();

  return (
    <FormField>
      <Input
        ariaLabel="Store Name"
        placeholder={t('ENTER_YOUR_STORE_NAME')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        dataHook={dataHooks.StoreNameInput}
        size="large"
        className={s.storeNameInput}
      />
    </FormField>
  );
}
